// Owner correction: restore the nocturnal neon identity lost during the detail pass.
// Light is concentrated on entertainment, food and garage fronts; homes remain quieter.
import type {HdBuilding} from '../../common/src/data';
import type {LightFn} from './hd-registry';
import {type G,K,HT,px,frame,alpha} from './hd-kit';
const PINK=new Set(['top-club','top-hotel','top-snack','a-snack','a-love','b-pachinko','b-club','c-snack','c-karaoke','d-club','n-snack','n-karaoke','n-bar','n-konbini','n-hotel','n-arcade','n-pachinko','pachinko','konbini','ks-bar','ks-motel','ks-pachinko','ks-karaoke','ks-arcade','ks-oni-hq','ks-bar-m','ke-bar','ke-hotel','ke-snack','se-karaoke','se-bar','sleep','bar-row','hotel-tower','arcade']);
const AMBER=new Set(['top-izakaya','b-yakitori','c-ramen','d-yakitori','n-izakaya','izakaya','ks-ramen','ks-noodle','ks-yakitori','ks-garage-w','ks-garage-e','ramen']);
/** Tube core + close halo are baked once, with street spill handled by the existing lighting system. */
function tube(g:G,x:number,y:number,w:number,h:number,c:string){
 px(g,x-3,y-3,w+6,h+6,alpha(c,.10));px(g,x-1,y-1,w+2,h+2,alpha(c,.25));px(g,x,y,w,h,c);
 if(w>h)px(g,x,y,w,1,K.warmHi);else px(g,x,y,1,h,K.warmHi);
}
export function paintNeonRestoration(g:G,b:HdBuilding,x:number,y:number,L:LightFn){
 const pink=PINK.has(b.id);if(!pink&&!AMBER.has(b.id))return;
 const w=b.w*HT,h=b.h*HT,f=b.face*HT,fy=y+h-f,c=pink?K.pink:K.amber;
 g.save();g.beginPath();g.rect(x,y,w,h);g.clip();
 // Wash masonry behind the sign, without flattening the detailed facade into a solid bright block.
 px(g,x+3,fy+3,w-6,f-7,alpha(c,pink?.10:.06));
 // Small frontages retain their readable letters; lights frame rather than overwrite them.
 const top=fy+(f<=64?3:5);
 tube(g,x+8,top,w-16,2,c);
 // Brighter jambs echo the old neon architecture, especially on arcades and nightlife fronts.
 if(pink){
  for(const xx of [x+6,x+w-8])tube(g,xx,fy+Math.min(35,f*.4),2,f-Math.min(35,f*.4)-7,c);
  L(x+9,fy+8,w-18,Math.min(24,f*.3),c,.48,false);
 }
 // The reflection source belongs near the pavement: high roof signs alone don't reach the street.
 // Break it into two shop-window pools to keep the middle route readable.
 const poolW=Math.min(64,Math.floor(w*.28));
 for(const xx of [x+13,x+w-13-poolW]){
  tube(g,xx,y+h-7,poolW,2,c);
  L(xx,y+h-15,poolW,10,c,pink?.48:.38,true);
 }
 // Taller hotels and Oni get a narrow vertical light, leaving windows visible.
 if(['hotel-tower','ks-motel','ks-oni-hq'].includes(b.id)){
  tube(g,x+w-6,fy+8,2,f-18,c);L(x+w-9,fy+12,7,f-25,c,.32,false);
 }
 g.restore();
}
